import chartItemTemplate from './chartItem.html';

const chartItem = {
    bindings: {
        campaignDetail: '=',
        callingPage: '@',
    },
    template: chartItemTemplate,
    controller: function (
        $filter,
        $element,
        $state,
        ApiPicklist,
        campaignFilterHistory
    ) {
        this.$filter = $filter;
        this.investmentColors = ['#e50045', '#f39200', '#94c11e'];
        this.lOIColors = [];
        this.defaultData = [1];
        let translateFilter = this.$filter('translate');
        this.defaultIOLLabel = [
            translateFilter('NO_CAMPAIGN_CONTACTS_ASSIGNED'),
        ];
        this.defaultInvestmentLabel = [
            translateFilter('TARGET_INVESTMENT') +
                ': ' +
                this.campaignDetail.currency +
                '0',
        ];
        this.defaultColor = ['#cdd5d9'];
        this.levelOfInterests = [];
        const currency = this.campaignDetail.currency;

        this.$onInit = () => {
            ApiPicklist.retrieveLevelsOfInterest().then((levelsOfInterest) => {
                this.levelOfInterests = levelsOfInterest.data;
                this.lOIColors = levelsOfInterest.data.map(
                    (item) => item.color
                );
            });

            this.presetChart();
        };

        this.presetChart = () => {
            if (this.callingPage == 'campaign-detail')
                this.toggleView(false, true, false, false);
            else this.toggleView(true, true, true, true);
        };

        this.getTooltiplabel = (tooltipItem, data) => {
            let numberFilter = this.$filter('number');
            return (
                data.labels[tooltipItem.index] +
                ': ' +
                this.campaignDetail.currency +
                numberFilter(data.datasets[0].data[tooltipItem.index], 0)
            );
        };
        this.defaultLabel = (tooltipItem, data) => {
            return data.labels[tooltipItem.index];
        };

        this.chartOptions = {
            tooltips: {
                enabled: false,
                custom: function (tooltip) {
                    // Tooltip Element
                    let tooltipEl = $element.find('table')[0].parentElement;

                    //Hide if no tooltip
                    if (tooltip.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines;
                    }

                    // Set Text
                    if (tooltip.body) {
                        const bodyLines = tooltip.body.map(getBody);
                        let innerHtml = '<thead>';
                        innerHtml += '</thead><tbody>';
                        bodyLines.forEach(function (body, i) {
                            const values = body[0].split(': ');
                            const label =
                                values[0] +
                                ': ' +
                                currency +
                                $filter('number')(values[1]);
                            innerHtml += '<tr><td>' + label + '</td></tr>';
                        });
                        innerHtml += '</tbody>';

                        let tableRoot = tooltipEl.querySelector('table');
                        tableRoot.innerHTML = innerHtml;
                    }

                    const positionY = this._chart.canvas.offsetTop;
                    const positionX = this._chart.canvas.offsetLeft;

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;

                    tooltipEl.style.left = positionX + tooltip.x + 'px';
                    tooltipEl.style.top = positionY + tooltip.y + 'px';
                    tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                    tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
                    tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                    tooltipEl.style.padding =
                        tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
                },
            },
        };
        this.campaignDetailsOptions = {
            tooltips: { callbacks: { label: this.getTooltiplabel } },
        };
        this.defaultChartOptions = {
            tooltips: { callbacks: { label: this.defaultLabel } },
        };
        this.defaultIOLOptions = {
            tooltips: {
                enabled: false,
                custom: function (tooltip) {
                    // Tooltip Element
                    let tooltipEl = $element.find('table')[0].parentElement;

                    //Hide if no tooltip
                    if (tooltip.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines;
                    }

                    // Set Text
                    if (tooltip.body) {
                        const bodyLines = tooltip.body.map(getBody);
                        let innerHtml = '<thead>';
                        innerHtml += '</thead><tbody>';
                        bodyLines.forEach(function (body, i) {
                            const values = body[0].split(': ');
                            innerHtml += '<tr><td>' + values[0] + '</td></tr>';
                        });
                        innerHtml += '</tbody>';

                        let tableRoot = tooltipEl.querySelector('table');
                        tableRoot.innerHTML = innerHtml;
                    }

                    const positionY = this._chart.canvas.offsetTop;
                    const positionX = this._chart.canvas.offsetLeft;

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;

                    tooltipEl.style.left = positionX + tooltip.x + 'px';
                    tooltipEl.style.top = positionY + tooltip.y + 'px';
                    tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                    tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
                    tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                    tooltipEl.style.padding =
                        tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
                },
            },
        };

        this.toggleView = (
            heading,
            investmentStatus,
            investmentStatusLegend,
            intrestLevel
        ) => {
            this.heading = heading;
            this.investmentStatus = investmentStatus;
            this.investmentStatusLegend = investmentStatusLegend;
            this.intrestLevel = intrestLevel;
        };

        this.getClass = () => {
            let ngclass = '';
            switch (this.callingPage) {
                case 'campaign-detail':
                    ngclass = '';
                    break;

                default:
                    ngclass = 'card';
                    break;
            }
            return ngclass;
        };

        this.getCampaignUrl = (campaignId, level = null) => {
            return $state.href('campaignDetail', {
                campaignId: campaignId,
                sortOrder: null,
                level: level ? level.apiKey : null,
            });
        };

        this.updateFilter = (level = null) => {
            if (level) {
                campaignFilterHistory.saveCampaignContactFilter(
                    this.levelOfInterests,
                    level.apiKey
                );
            }
        };

        this.chartClick = (points) => {
            let loiItem = null;
            let companyId = null;

            if (points[0]._chart.canvas.dataset.companyId) {
                companyId = points[0]._chart.canvas.dataset.companyId;
            }

            if (points[0]._model.label) {
                const label = points[0]._model.label;
                loiItem = this.levelOfInterests.find((item) => {
                    return (
                        translateFilter(item.name).toLowerCase() ===
                        label.toLowerCase()
                    );
                });
            }

            if (loiItem) {
                campaignFilterHistory.saveCampaignContactFilter(
                    this.levelOfInterests,
                    loiItem.apiKey
                );
                $state.go('campaignDetail', {
                    campaignId: companyId,
                    sortOrder: null,
                    level: loiItem.apiKey,
                });
            }
        };
    },
};

export default chartItem;



/** WEBPACK FOOTER **
 ** ./src/app/directives/chartItem/chartItem.js
 **/